import { render, staticRenderFns } from "./dialogsHeader.vue?vue&type=template&id=83d3ab5c&scoped=true&"
import script from "./dialogsHeader.vue?vue&type=script&lang=js&"
export * from "./dialogsHeader.vue?vue&type=script&lang=js&"
import style0 from "./dialogsHeader.vue?vue&type=style&index=0&id=83d3ab5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d3ab5c",
  null
  
)

export default component.exports